import { Outlet } from 'react-router';
import { ModuleHooksRunner } from '../../data/ModuleHooksRunner';
import { ConnectionToastHost } from '../../ui/ConnectionToast';
import { ToastHost } from '../../ui/ToastHost';
import { BottomNav, SideNav } from './BottomNav';
import { StorageBanner } from './StorageBanner';

/**
 * Phones: 16px side gutter, room for the pill nav, safe areas for installed iPhone apps.
 * 768px+: a wider centered column. 1024px+: the side nav replaces the bottom bar.
 */
export function AppShell() {
  return (
    <div className="min-h-dvh lg:pl-60">
      <SideNav />
      <div className="mx-auto max-w-lg px-4 pt-[calc(16px+env(safe-area-inset-top))] pb-[calc(96px+env(safe-area-inset-bottom))] md:max-w-3xl md:px-6 md:pt-8 lg:max-w-5xl lg:px-10 lg:pb-12">
        <ModuleHooksRunner />
        <StorageBanner />
        <Outlet />
      </div>
      <ConnectionToastHost />
      <ToastHost />
      <BottomNav />
    </div>
  );
}
